import { useState } from 'react';
import { FormControl } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import BasicTextField from './BasicTextField';
import Events from '../../../defaults/Events';

const theme = createTheme({
    overrides: {},
});

export default function DetailsInteragencyText({
    id,
    item,
    field,
    otherInteragencySelected,
    setOtherInteragencySelected,
    geoID,
    geoType,
    userInfo,
    isDisabled = false,
}) {
    const [value, setValue] = useState(item);

    return (
        <FormControl variant='standard' fullWidth>
            <ThemeProvider theme={theme}>
                <BasicTextField
                    id={id}
                    value={value}
                    setValue={setValue}
                    field={field}
                    otherInteragencySelected={otherInteragencySelected}
                    setOtherInteragencySelected={setOtherInteragencySelected}
                    label=''
                    variant={'standard'}
                    placeholder={''}
                    useFullWidth={true}
                    helperText={isDisabled ? '' : 'Please enter a value.'}
                    geoID={geoID}
                    geoType={geoType}
                    userInfo={userInfo}
                    useMultiline={true}
                    isDisabled={isDisabled}
                    triggerEvent={Events.TriggerInteragencyFieldChange}
                    index={id}
                />
            </ThemeProvider>
        </FormControl>
    );
}
